var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
var ReportContext = createContext({
    isDirty: false,
    setIsDirty: function () { },
    confirmExit: null,
    setConfirmExit: function () { },
    filterParams: {},
    setFilterParams: function () { },
});
export var ReportProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isDirty = _b[0], setIsDirty = _b[1];
    var _c = useState(null), confirmExit = _c[0], setConfirmExit = _c[1];
    var _d = useState({}), filterParams = _d[0], setFilterParams = _d[1];
    var value = useMemo(function () { return ({
        isDirty: isDirty,
        setIsDirty: setIsDirty,
        confirmExit: confirmExit,
        setConfirmExit: setConfirmExit,
        filterParams: filterParams,
        setFilterParams: setFilterParams,
    }); }, [isDirty, confirmExit, filterParams, setIsDirty, setConfirmExit, setFilterParams]);
    return _jsx(ReportContext.Provider, __assign({ value: value }, { children: children }));
};
export var useReportContext = function () { return useContext(ReportContext); };
